{
  "en": {
    "sharedLibrary": {
      "title": "Shared Storage",
      "subline": "Here your colleagues provide templates for everyday school life – visible only to your school.\nCopy what you need and add what helps others.",
      "tutorial": "View tutorial",
      "badge": {
        "schoolLicenseOnly": "Only with fobizz School License"
      },
      "licenseTeaser": {
        "title": "Your School's Material Cabinet",
        "text": "Here your colleagues provide templates for everyday school life – visible only to your school. Copy what you need and add what helps others.",
        "hasLicense": {
          "question": "Does your institution already have a license?",
          "placeholder": "Enter school license code…",
          "success": "School license activated! You are now a member of \"{groupTitle}\"."
        },
        "noLicense": {
          "question": "Does your institution not have a license yet?",
          "requestLink": "Request for my school",
          "requestUrl": "https://fobizz.com/en/offers-for-schools-and-groups/"
        }
      },
      "createMenu": {
        "hint": "AI Assistants and multimedia tools can only be copied here from your storage."
      },
      "search": {
        "placeholder": "Search shared storage..."
      },
      "actions": {
        "copyToMyContent": "Copy to My Storage",
        "copyToMyContentPending": "Copying to My Content…",
        "copyToSharedLibrary": "Copy to Shared Space",
        "copyToSharedLibraryDescription": "(Original remains unchanged)",
        "copyFolderNotSupported": "Not yet possible for folders"
      },
      "folderNotSupported": {
        "title": "Folders cannot be copied to the Shared Space yet",
        "selectionHint": "Select the contents in the folder and copy them individually or together."
      },
      "copyDialog": {
        "title": "Copy to shared folder",
        "school": "School",
        "folder": "Folder",
        "createFolder": "Create new folder",
        "newFolderName": "New folder name",
        "folderLoadError": "The folders could not be loaded. Please try again."
      },
      "moveDialog": {
        "mixedSelection": "The selected content is in different folders. Moving is only possible within a single folder – select content from only one folder."
      },
      "copyResult": {
        "success": "Content was successfully copied to the Shared Space",
        "failure": "Your selection could not be copied to the Shared Space",
        "retry": "Please try again.",
        "responsesNotCopied": "Your students' submissions will not be copied"
      },
      "adoptDialog": {
        "title": "Copy to My Storage",
        "folder": "Folder"
      },
      "adoptResult": {
        "success": "Content successfully copied to My Content",
        "failure": "Your selection could not be copied to My Content"
      },
      "schoolSelect": {
        "ariaLabel": "Change School",
        "hint": "Here you can select your school"
      },
      "links": {
        "backToLibrary": "To Shared Space",
        "trash": "View Trash"
      },
      "emptyState": {
        "root": "There is no content in your school's Shared Space yet.",
        "folder": "There is currently no content in this folder."
      },
      "noAccess": {
        "noSchool": {
          "title": "You are not yet assigned to a school",
          "text": "The Shared Space always belongs to a school. Once you are assigned to a school, you will find your colleagues' materials here."
        },
        "disabledBySchool": {
          "title": "Your school has disabled Shared Spaces",
          "text": "Shared Spaces is turned off for your school. Contact your school's license administration if you would like to use it again."
        },
        "refusedBySchool": {
          "title": "This Shared Space is no longer available to you",
          "text": "Your school is currently not granting you access to this Shared Space. This happens when your membership has ended or your school has deactivated the Shared Space. Reload the page or contact your school's license management."
        }
      },
      "copySelectionDialog": {
        "title": "Copy selection to Shared Spaces",
        "school": "School",
        "createFolder": "Create new folder",
        "newFolderName": "Name of the new folder"
      },
      "trash": {
        "heading": "Trash",
        "buttons": {
          "clear": "Empty Trash"
        },
        "emptyTable": "There are currently no removed items in your school's Shared Spaces trash.",
        "subline": "Deleted materials and folders remain in the trash for <strong>30 days</strong>. They can be restored until then, after which they will be permanently removed."
      }
    }
  }
}
